module.exports = __webpack_public_path__ + "static/img/paint.cf18735b.webp";